import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            border: 'small',
            borderColor: 'border.light',
            cursor: 'pointer',
            borderRadius: remCalc(12),
            padding: `${remCalc(20)} ${remCalc(16)}`,
            gap: remCalc(16),
        },
        header: {
            alignItems: 'center',
            color: 'text.default',
            fontSize: '1em',
            fontWeight: 'normal',
            justifyContent: 'space-between',
            position: 'relative',
            transition: 'background 0.1s ease-out',
            width: '100%',
            background: 'background.default',
        },
        radioContainer: {
            display: 'flex',
            flexWrap: 'nowrap',
        },
        radioStyle: {
            width: remCalc(16),
            height: remCalc(16),
            marginRight: remCalc(20),
            backgroundColor: 'background.default',
        },
        selectedStyle: {
            height: remCalc(6),
            width: remCalc(6),
            margin: remCalc(4),
            backgroundColor: 'background.default',
        },
        image: {
            marginRight: remCalc(12),
        },
    },
}
